module.exports = __webpack_public_path__ + "static/media/font_regular.0954afca.woff2";